import React from 'react';

export const EmptyStateButtonSeparator = ({ children }: React.PropsWithChildren) => {
  return <span className="body-6">{children}</span>;
};
